@if (distribution().length > 0) {
  <div class="space-y-1.5">
    <!-- Average Grade -->
    @if (averageGrade(); as avg) {
      <div class="flex items-center gap-2 mb-2">
        <lucide-icon
          [img]="icons.Target"
          class="w-4 h-4 text-violet-500"
        ></lucide-icon>
        <span class="text-xs text-gray-600">
          Average:
          <span class="font-semibold" [ngClass]="averageGradeColorClass()">
            {{ avg }}
          </span>
        </span>
      </div>
    }

    <!-- Grade Bars -->
    @for (entry of distribution(); track entry.grade) {
      <div class="flex items-center gap-2">
        <!-- Grade Label -->
        <span class="w-4 text-[10px] font-semibold text-gray-600">
          {{ entry.grade }}
        </span>
        <!-- Bar Container -->
        <div class="flex-1 h-4 bg-gray-100 rounded-full overflow-hidden">
          @if (entry.count > 0) {
            <div
              class="h-full rounded-full transition-all duration-500 ease-out flex items-center justify-end pr-1.5"
              [ngClass]="entry.bgColorClass"
              [style.width.%]="entry.percentage"
              [style.min-width]="entry.count > 0 ? '1.5rem' : '0'"
            >
              <span class="text-[9px] font-semibold text-white">
                {{ entry.count }}
              </span>
            </div>
          }
        </div>
        <!-- Percentage -->
        <span class="w-8 text-[10px] text-gray-400 text-right">
          {{ entry.percentage | number: '1.0-0' }}%
        </span>
      </div>
    }
  </div>
}
